import React, { useEffect, useState } from 'react';
import { useMutation } from '@apollo/client';
import Arrow from 'components/Icons/Arrow';
import PriceBadge from 'components/Others/PriceBadge';
import { getAccessorieName } from 'functions/getProductName';
import { GetStaticPaths, GetStaticProps } from 'next';
import dynamic from 'next/dynamic';
import Head from 'next/head';
import Image from "next/legacy/image";
import { useRouter } from 'next/router';
import { useDispatch, useSelector } from 'react-redux';
import { Navigation, Swiper as SwiperInstance, Thumbs } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import { bundleProductTagsMap, formatVisiblePrice, getSeoMetaTags, getUrlByLocale } from 'utils/common.utils';
import { getContactLensesImageV2 } from 'utils/image.utils';
import { v4 as uuidv4 } from 'uuid';
import Breadcrumb from '../../../../components/Breadcrumb/Breadcrumb';
import Button from '../../../../components/Button/Button';
import Spinner from '../../../../components/Spinner/Spinner';
import { getLocalCurrency } from '../../../../functions/currency';
import 'swiper/css';
import { addDataLayer } from '../../../../lib/ga';
import { sendAddToCartEvent } from '../../../../lib/tracking';
import {
  setLoading,
} from '../../../../redux/features/bag/bagSlice';
import { RootState } from '../../../../redux/store';
import PrescriptionAlt from 'components/Icons/PrescriptionAlt';
import ShippingIcon from 'components/Icons/ShippingIcon';
import ReturnIcon from 'components/Icons/ReturnIcon';
import ProductTag from 'components/Others/ProductTag';
import { wcApiDataService } from 'functions/wcApi';
import { addToCart, addToCartContactLens } from 'redux/features/cart/cartSlice';
import { CREATE_CART } from 'gqlStrings/mutations/addToCart';
import AfterPayInfo from 'components/Others/AfterPayInfo';
import ZipPayInfo from 'components/Others/ZipPayInfo';
import { InfoIcon } from 'components/Icons/Info';
import { getSession } from 'functions/session';
import GlobalSeoMetaTags from 'components/GlobalSeoMetaTags/GlobalSeoMetaTags';
import DocumentUpload from 'components/Icons/DocumentUpload';
import Checkmark from 'components/Icons/Checkmark';
import Resizer from 'react-image-file-resizer';
import { ALLOWED_FILE_EXTENSIONS } from 'components/Prescription/PrescriptionUploadDropzone';
import { useForm } from 'react-hook-form';
import TrashAlt from 'components/Icons/TrashAlt';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import axios from 'axios';
import MarkerS from 'components/Icons/MarkS';

const MySwal = withReactContent(Swal)

var md5 = require('md5');
const UITooltip = dynamic(() => import('components/Others/UITooltip'), { ssr: false });


export default function ContactLenses({
  product,
  seoMetaTags
}: {
  product: any;
  seoMetaTags: any;
}) {
  const data = product && [
    {
      id: 1,
      href: '',
      text: 'Dresden Vision'
    },
    {
      id: 2,
      href: 'shop',
      text: 'Shop'
    },
    {
      id: 3,
      href: 'shop/contact-lenses',
      text: 'Contact Lenses'
    },
    {
      id: 4,
      href: `shop/contact-lenses/${product.slug}`,
      text: product.name
    }
  ];

  const router = useRouter();
  const dispatch = useDispatch();
  const isLoad = useSelector((state: RootState) => state.bagEvent.loading);
  const bagItems = useSelector((state: RootState) => state.bagEvent.bag);
  const [samePriscription, setSamePriscription] = useState(false);
  const [lensExtraOptions, setLensExtraOptions] = useState<any>({
    "quantityR": 0,
    "quantityL": 0
  });
  const [disabledAddToCard, setDisabledAddToCart] = useState(true);
  const [swiperInstance, setSwiperInstance] = useState<SwiperInstance | null>(
    null
  );
  const [swiperActiveIndex, setSwiperActiveIndex] = useState(0);

  (swiperInstance && !swiperInstance.destroyed) && swiperInstance.on('activeIndexChange', () => {
    setSwiperActiveIndex(swiperInstance.realIndex)
  })

  const navigateToCarouselSlide = (index: number) => {
    swiperInstance?.slideTo(index + 1);
    swiperInstance?.update();
  };

  const hasAttribute = (attributes: any, slug: string) => {
    return attributes?.filter((item: any) => item.slug === slug).length > 0;
  }
  //console.log('product', product?.attributes?.filter((item: any) => item.slug === 'pa_bundle-box-count'));

  const isBundled = hasAttribute(product.attributes, 'pa_bundle-box-count');
  const bundlePackSize = product?.attributes?.filter((item: any) => item.slug === 'pa_bundle-box-count')[0]?.options[0];
  const price = product?.meta.price;
  const packSize = product?.attributes?.filter((item: any) => item.slug == 'pa_pack-size')?.[0]?.options?.[0];
  const frequency = product?.attributes?.filter((item: any) => item.slug == 'pa_frequency')?.[0]?.options?.[0];
  const lensType = product?.attributes?.filter((item: any) => item.slug == 'pa_contact-lens-type' && item.options?.[0] != 'sphere')?.[0]?.options?.[0];
  const images = product.meta.product_images.map((image: any) => image.includes('contact-lenses/v2/') ? image : image.replace('contact-lenses/', 'contact-lenses/v2/'));

  const [quantity, setQuantity] = useState(Number(lensExtraOptions.quantityR) + Number(lensExtraOptions.quantityL));
  const [fileUpload, setFileUpload] = useState(false);
  const [file, setFile] = useState(null);
  const [fileRemoved, setFileRemoved] = useState(false);
  const [fileRemovedLoading, setFileRemovedLoading] = useState(false);
  const [fileSrc, setFileSrc] = useState<any>(null);
  const [fileIsPdf, setFileIsPdf] = useState<any>(false);
  const [fileName, setFileName] = useState<any>(null);
  const isLogin = useSelector((state: RootState) => state.authEvent.isLogin);


  const hasXRTag = product?.tags?.filter((item: any) => item.slug == 'xr').length > 0;
  //const withColor = hasAttribute(product.attributes, 'pa_contact-lens-colour');
  const [activeTabIndex, setActiveTabIndex] = useState(product?.description ? 0 : product?.meta?.technical_details ? 1 : 2);
  const [mutateCreateCart] = useMutation(CREATE_CART, {
    context: { clientName: 'laravel' }
  });

  const {
    register,
    watch,
    handleSubmit,
    control,
    setValue,
    formState: { errors, isSubmitting },
    clearErrors
  } = useForm({
    mode: 'onChange',
    defaultValues: {
      file: null
    }
  });
  const uploadedFile: any = watch('file');

  /* eslint-disable @next/next/no-html-link-for-pages */
  const cLTooltipMessageLocale = {
    au: <div><span className='font-medium'>A valid prescription within the past 12 months is required for the supply of contact lenses.</span> Don't have a valid prescription? <a className="text-brand-blue" href="/au/book-an-optometrist">Book an appointment</a> with us or call us at (02) 5300 3003.</div>,
    ca: <div><span className='font-medium'>A valid prescription within the past 12 months is required for the supply of contact lenses.</span> Don't have a valid prescription? <a className="text-brand-blue" href="/ca/book-an-eye-exam">Book an appointment</a> with us or call us at (647) 424 4288.</div>,
    nz: <div><span className='font-medium'>A valid prescription within the past 12 months is required for the supply of contact lenses.</span> Don't have a valid prescription? <a className="text-brand-blue" href="/book-an-eye-exam">Book an appointment.</a></div>,
    international: <div><span className='font-medium'>A valid prescription within the past 12 months is required for the supply of contact lenses.</span> Don't have a valid prescription? Call us at (02) 5300 3003.</div>,
  }
  const [haveValidPrescription, setHaveValidPrescription] = useState(false)

  useEffect(() => {
    const totalProductQuantity = Number(lensExtraOptions.quantityR) + Number(lensExtraOptions.quantityL);
    setQuantity(Number(totalProductQuantity));
    checkValidation();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lensExtraOptions, haveValidPrescription]);


  //Decode p parameter from query that has format {"r":{"bc":"8.60","mf":"Low","cyl":"-0.75","dia":"14.50","sph":"-1.25","axis":"180"},"l":{"bc":"8.60","mf":"High","cyl":"-1.75","dia":"14.50","sph":"-4.25","axis":"180"},"q":{"r":2,"l":2}}}
  //and convert it to format axisL:"20", axisR:"30", bcL:"8.60", bcR:"8.60", cylL:"-0.75", cylR:"-1.25", diaL:"14.50", diaR:"14.50", mfL:"Low", mfR:"High", quantityL:"2", quantityR:"1", sphL:"-5.75", sphR:"-6.00"
  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const p = urlParams.get('p');
    if (p) {
      const pData = atob(p).trim();
      const decodedP = JSON.parse(pData);
      const { r, l, q } = decodedP;
      const lensExtraOptions = {
        axisL: l.axis,
        axisR: r.axis,
        bcL: l.bc,
        bcR: r.bc,
        cylL: l.cyl,
        cylR: r.cyl,
        diaL: l.dia,
        diaR: r.dia,
        mfL: l.mf,
        mfR: r.mf,
        quantityL: q.l,
        quantityR: q.r,
        sphL: l.sph,
        sphR: r.sph,
        addtypeR: r.addtype,
        addtypeL: l.addtype
      };
      setLensExtraOptions(lensExtraOptions);
    }
  }, []);

  useEffect(() => {
    if (process.browser && !getSession()) {
      mutateCreateCart({
        variables: {
          input: {
            isEmpty: true
          }
        }
      });
    }
  }, [mutateCreateCart]);

  const uuidv4R = uuidv4();
  const uuidv4L = uuidv4();

  const getPrescription = (direction: string, type: string) => {
    var prescription = Object.fromEntries(Object.entries(lensExtraOptions).filter(([key]) => key[key.length - 1] == direction).map((item) => {
      item[0] = item[0].slice(0, -1);
      if (item[0] !== 'quantity') {
        return item;
      }
      return [];
    }).filter((prescription: any) => prescription.length > 0));
    if (type === 'hash') {
      return md5(JSON.stringify(prescription));
    }

    return prescription;
  }

  if (router.isFallback) {
    return (
      <div className="h-[70vh] items-center justify-center flex">
        Loading...
      </div>
    );
  }


  const getSeoImage = () => {
    return getContactLensesImageV2(product);
  }

  function handleCustomSelectChange(event: any) {
    setLensExtraOptions({ ...lensExtraOptions, [event.target.name]: event.target.value });
  }


  const handleFileUpload = async () => {
    if (uploadedFile && uploadedFile.length > 0) {
      const formData = new FormData();
      formData.append('file', uploadedFile[0]);

      const config: any = {
        headers: {}
      };

      if (isLogin) {
        config.headers.Authorization = `Bearer ${getSession()}`;
      }

      try {
        const response = await axios.post(
          `${process.env.NEXT_PUBLIC_LARAVEL_URL}/uploadContactLensPrescription`,
          formData,
          config
        );

        if (response.status === 200) {
          return response.data;
        }
      } catch (error) {
        console.error('File upload failed:', error);
      }

      return false;
    }
  };



  const checkValidation = () => {
    if (Number(lensExtraOptions.quantityR) + Number(lensExtraOptions.quantityL) > 0 && haveValidPrescription) {
      if (Number(lensExtraOptions.quantityR) > 0 && haveValidPrescription) {
        const options = Object.fromEntries(Object.entries(lensExtraOptions).filter(([key]) => key[key.length - 1] == 'R'))
        setDisabledAddToCart(!Object.keys(options).every((item) => options[item] != '-'))
      }

      if ((Number(lensExtraOptions.quantityL) > 0) && haveValidPrescription) {
        const options = Object.fromEntries(Object.entries(lensExtraOptions).filter(([key]) => key && key[key.length - 1] == 'L'))
        setDisabledAddToCart(!Object.keys(options).every((item) => options[item] != '-'))
      }

      if ((Number(lensExtraOptions.quantityL) > 0 && Number(lensExtraOptions.quantityR) > 0) && haveValidPrescription) {
        setDisabledAddToCart(!Object.keys(lensExtraOptions).every((item) => lensExtraOptions[item] != '-'))
      }
    } else {
      setDisabledAddToCart(true);
    }
  }

  interface IPriscriptionSelect {
    options?: string;
    cType?: string;
    renderEmptyValue?: Boolean
  }

  const PriscriptionSelect: React.FC<IPriscriptionSelect> = ({ options, cType, renderEmptyValue = true }) => {

    let optionsArray: any = [];


    if (options) {
      optionsArray = options.split(',');
    }

    useEffect(() => {
      if (cType && !lensExtraOptions[cType]) {
        setLensExtraOptions({ ...lensExtraOptions, [cType]: optionsArray.length == 1 ? optionsArray[0] : cType.includes('quantity') ? '0' : '-' });
      }
    }, [cType]);

    return (
      <div className={"flex px-2 relative flex-col rounded-[6px] w-full bg-white" + (optionsArray.length != 1 ? " border border-brand-grey400" : "")} >
        {optionsArray.length == 1 && <div className="text-sm leading-10">{optionsArray[0]}</div>}
        {(optionsArray.length > 1 && cType) && <select name={cType} value={lensExtraOptions[cType]} onChange={handleCustomSelectChange} className="pb-3 pr-4 dresden-select invalid:text-white pt-2 bg-transparent cursor-pointer appearance-none text-sm focus:outline-none bg-brand-grey125 text-brand-grey300">
          {renderEmptyValue && <option>-</option>}
          {optionsArray && optionsArray.map((opt: any, index: any) => (
            <option key={index} value={opt}>
              {opt}
            </option>
          ))}
        </select>
        }
      </div>
    )
  }

  interface IPriscriptionField {
    title?: string;
    rawData: string;
    bold?: boolean;
    renderEmptyValue?: boolean;
  }

  const LensPriscriptionField: React.FC<IPriscriptionField> = ({ title, rawData, bold = false, renderEmptyValue = true }) => {
    //const [data, setData] = useState(rawData);
    const powerRangeMapping: Record<string, string> = {
      'bc': 'Base Curve',
      'dia': 'Diameter',
      'sph': 'Sphere',
      'cyl': 'Cylinder',
      'axis': 'Axis',
      'mf': 'Add',
      'addtype': 'Add type'
    }
    if (!title) {
      title = powerRangeMapping[rawData?.split(':')[0]]
    }

    const options = rawData?.split(':')[1];
    return (

      <div className="flex flex-col mdx:flex-row items-center mr-3 text-center mdx:mb-5">
        <div className={"h-7 mdx:min-w-[100px] text-[13px] mdx:text-left whitespace-nowrap" + (bold ? ' font-medium' : '')}>{title}</div>
        <div className={"text-center min-w-[68px] md:max-w-[120px] mdx:w-[100px] bg-[#FEFEFE] rounded-md h-10 text-[grey300] leading-10 md:mt-2" + (samePriscription ? " mdx:w-[150px]" : "")}>
          <PriscriptionSelect options={options} renderEmptyValue={renderEmptyValue} cType={`${rawData?.split(':')[0]}R`} />
        </div>
        {!samePriscription && <div className="text-center min-w-[68px] md:max-w-[120px] mdx:w-[100px] mdx:ml-2 bg-[#FEFEFE] rounded-md h-10 text-[grey300] leading-10 md:mt-5">
          <PriscriptionSelect options={options} renderEmptyValue={renderEmptyValue} cType={`${rawData?.split(':')[0]}L`} />
        </div>}
      </div>

    )
  }

  interface IPowerRange {
    powerRange: string;
  }
  const LensPowerRanges: React.FC<IPowerRange> = ({ powerRange }) => {
    if (!powerRange) return null
    const parsedData = powerRange.split(';');
    return (
      <>
        {parsedData.map((item, index) => {
          return (<LensPriscriptionField key={index} rawData={item} />)
        })}
      </>
    )
  }

  const getProperContent = (htmlContent: any) => {
    if (router.locale !== 'international') {
      return htmlContent.replaceAll('/shop', '/' + router.locale + '/shop');
    }
    return htmlContent;
  }

  const fileErrorPopup = () => {
    console.log('fileErrorPopup');
    return MySwal.fire({
      width: 380,
      html: (
        <div>
          <p className="text-base font-medium">
            The file you uploaded is either too large or not properly formatted. Please check the file and try again.
          </p>
          <div className="mt-4 flex w-full items-center justify-center">
            <button
              className="mr-3 rounded bg-brand-black50 px-5 py-2 text-sm text-white"
              onClick={() => MySwal.close()}>
              OK
            </button>
          </div>
        </div>
      ),
      showConfirmButton: false
    })
  }

  const handleAddtoCart = async () => {
    dispatch(setLoading(true));

    const filePath = await handleFileUpload();
    let extraData: any;
    const session = getSession();

    if (session && !isBundled) {
      var contactLensAddToCartData: any = [];
      if (lensExtraOptions.quantityR > 0) {
        extraData = {
          productName: product.name,
          productLink: router.asPath,
          productType: 'contact-lens',
          contactLensType: 'Right eye',
          region_product_id: product?.meta?.region_product_ids,
          imagePath: product?.meta.product_images[0],
          prescription: getPrescription('R', 'object'),
          prescriptionHash: getPrescription('R', 'hash'),
        };

        if (filePath && filePath.id) {
          extraData.prescriptionImage = filePath.id;
          extraData.prescriptionImageUrl = filePath.public_path;
        }

        contactLensAddToCartData.push({
          variables: {
            queueId: uuidv4R,
            input: {
              productId: product.post_id,
              clientMutationId: session,
              quantity: Number(lensExtraOptions.quantityR),
              extraData: JSON.stringify(extraData)
            }
          }
        });
      }

      if (lensExtraOptions.quantityL > 0) {
        let extraDataL: any = {
          productName: product.name,
          productLink: router.asPath,
          productType: 'contact-lens',
          contactLensType: 'Left eye',
          region_product_id: product?.meta?.region_product_ids,
          imagePath: product?.meta.product_images[0],
          prescription: getPrescription('L', 'object'),
          prescriptionHash: getPrescription('L', 'hash'),
        };

        if (filePath) {
          extraDataL.prescriptionImage = filePath;
        }

        contactLensAddToCartData.push({
          variables: {
            queueId: uuidv4L,
            input: {
              productId: product.post_id,
              clientMutationId: session,
              quantity: Number(lensExtraOptions.quantityL),
              extraData: JSON.stringify(extraDataL)
            }
          }
        });
      }
      dispatch(addToCartContactLens(contactLensAddToCartData))

      // Google Analytics tracking
      addDataLayer({
        event: 'addToCart',
        ecommerce: {
          currencyCode: getLocalCurrency(router.locale),
          add: {
            products: [
              {
                name: product.name,
                price: price,
                category: 'Contact Lenses',
                quantity: quantity
              }
            ]
          }
        }
      });

      // Meta Conversion API tracking
      sendAddToCartEvent({
        product_id: `contact-lenses-${product.slug}`,
        product_name: product.name,
        value: Number(isBundled ? price : price * quantity),
        currency: getLocalCurrency(router.locale),
        content_category: 'Contact Lenses',
        contents: [
          {
            id: `contact-lenses-${product.slug}`,
            quantity: quantity,
            item_price: Number(price)
          }
        ]
      });
    }

    if (session && isBundled) {
      let data: any = {
        productName: product.name,
        productLink: router.asPath,
        productType: 'contact-lens',
        contactLensType: 'Bundle',
        region_product_id: product?.meta?.region_product_ids,
        imagePath: product?.meta.product_images[0],
        prescriptionL: getPrescription('L', 'object'),
        prescriptionHashL: getPrescription('L', 'hash'),
        prescriptionR: getPrescription('R', 'object'),
        prescriptionHashR: getPrescription('R', 'hash'),
      }

      if (filePath) {
        data.prescriptionImage = filePath;
      }

      dispatch(addToCart({
        type: 'simple',
        variables: {
          queueId: uuidv4L,
          input: {
            productId: product.post_id,
            clientMutationId: session,
            quantity: 1,
            extraData: JSON.stringify(data)
          }
        }
      }))

      // Google Analytics tracking
      addDataLayer({
        event: 'addToCart',
        ecommerce: {
          currencyCode: getLocalCurrency(router.locale),
          add: {
            products: [
              {
                name: product.name,
                price: price,
                category: 'Contact Lenses',
                quantity: 1
              }
            ]
          }
        }
      });

      // Meta Conversion API tracking
      sendAddToCartEvent({
        product_id: `contact-lenses-${product.slug}`,
        product_name: product.name,
        value: Number(price),
        currency: getLocalCurrency(router.locale),
        content_category: 'Contact Lenses',
        contents: [
          {
            id: `contact-lenses-${product.slug}`,
            quantity: 1,
            item_price: Number(price)
          }
        ]
      });
    }
  }


  const clPrescriptionFieldContentForLocale = {
    au: <span>Don't have a valid prescription? <a className="text-brand-blue" href="/au/book-an-optometrist">Book an appointment with us</a> or call us at <a href="tel:+0253003003">(02) 5300 3003</a>.</span>,
    ca: <span>Don't have a valid prescription? <a className="text-brand-blue" href="/ca/book-an-eye-exam">Book an appointment with us</a> or call us at <a href="tel:+6474244288">(647) 424 4288</a>.</span>,
    nz: <span>Don't have a valid prescription? <a className="text-brand-blue" href="/nz/book-an-eye-exam">Book an appointment with us</a> or call us at <a href="tel:+0253003003">(02) 5300 3003</a>.</span>,
    international: <span>Don't have a valid prescription? Call us at <a href="tel:+0253003003">+1 (213) 223-6100</a>.</span>
  }
  if (!product) {
    return null;
  }

  const pageTitle = product.name + ' | Dresden Vision';

  return (
    <div className="w-full relative">
      <Head>
        <meta
          name="twitter:title"
          content={product.name}
        />
        <meta
          name="og:title"
          content={product.name}
        />
        <meta
          name="description"
          content={`${product.name}  are on this page with advantageous price and Dresden Vision assurance. Shop ${product.name} online.`}
        />
        <meta
          property="og:description"
          content={`${product.name} are on this page with advantageous price and Dresden Vision assurance. Shop ${product.name} online.`}
        />
        <meta
          name="twitter:description"
          content={`${product.name} are on this page with advantageous price and Dresden Vision assurance. Shop ${product.name} online.`}
        />
        <meta property="og:image" content={`${getSeoImage()}`} />
        <meta property="twitter:image" content={`${getSeoImage()}`} />
        <title>{pageTitle}</title>

        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify({
              '@context': 'https://schema.org/',
              '@type': 'Product',
              name: product.name,
              image: [getSeoImage()],
              description: `${product.name} are on this page with advantageous price and Dresden Vision assurance. Shop ${product.name} online.`,
              brand: {
                '@type': 'Brand',
                name: 'DRESDEN VISION'
              },

              offers: {
                '@type': 'Offer',
                url:
                  `${process.env.NEXT_PUBLIC_SITE_URL}` +
                  `${router.locale}` +
                  `${router.asPath}`,
                priceCurrency:
                  router.locale === 'nz'
                    ? 'NZD'
                    : router.locale === 'ca'
                      ? 'CAD'
                      : 'AUD',
                price: price,
                itemCondition: 'https://schema.org/UsedCondition',
                availability: 'https://schema.org/InStock'
              }
            })
          }}
        />
      </Head>
      <div className="bg-[#F8F8F8]">
        <div className="max-w-[1224px] mx-auto px-4 pt-6">
          <Breadcrumb data={data} />

          <div className="grid grid-cols-2 gap-x-10 xlx:grid-cols-1 mt-4 pb-12">
            <div className="w-full sticky top-[20px] z-[22] xlx:static">
              <div className="relative w-full h-[420px] flex items-center justify-center bg-white border-2 border-brand-grey125 rounded xsmx:w-full xsmx:h-[280px] xlx:mx-auto">
                <div className='absolute z-10 text-right flex flex-col items-end right-4 top-4'>
                  {(product?.salePrice && isBundled) && <span className="mt-1"><ProductTag isSmall={true} text={`
                ${Math.round((1 - parseInt(product.meta.price) / parseInt(product.meta.regular_price)) * 100)}% Discount
                `} isAbsolute={false} textColor="#fff" backgroundColor="#47AC40" /></span>}
                  {isBundled && product?.productTags?.edges.filter((item: any) => item.node.slug != 'bundle').map((item: any, idx: any) => <div key={idx} className="mb-[5px] first-of-type:mt-[5px] z-10 text-center w-fit">
                    <ProductTag isSmall={true} text={bundleProductTagsMap[item?.node?.slug]} isAbsolute={false} textColor="#fff" backgroundColor="#FF8200" />
                  </div>)}
                  {isBundled && <div className="mb-[5px] first-of-type:mt-[5px] z-10 text-center w-fit">
                    <ProductTag isSmall={true} text={`${packSize * bundlePackSize} Lenses`} isAbsolute={false} textColor="#fff" backgroundColor="#FF8200" />
                  </div>}
                </div>
                <div className='w-full bg-[#f7fafb]'>
                  {images?.length == 1 && <Image
                    quality={75}
                    objectFit="cover"
                    priority
                    layout="fill"
                    src={images?.[0]}
                    alt={
                      getAccessorieName(product.name)
                    }
                  />}
                  <div className="group relative max-h-[420px] max-w-[650px] mx-auto">
                    {images?.length > 1 &&
                      <>
                        <button className="prevel absolute top-2/4 left-5 z-50 hidden h-8 w-8 -translate-y-2/4 rotate-90 transform items-center justify-center rounded-full bg-brand-grey125 opacity-50 transition-all hover:opacity-100 group-hover:flex mdx:hidden xsmx:left-3">
                          <Arrow fill="#5c615cd3" width={14} height={8} />
                        </button>
                        <button className="nextel absolute top-2/4 right-5 z-50 hidden h-8 w-8 -translate-y-2/4 -rotate-90 transform items-center justify-center rounded-full bg-brand-grey125 opacity-50 transition-all hover:opacity-100 group-hover:flex mdx:hidden xsmx:right-3">
                          <Arrow fill="#5c615cd3" width={14} height={8} />
                        </button>
                        <Swiper
                          modules={[Navigation, Thumbs]}
                          loop
                          className="w-full h-full"
                          onSwiper={setSwiperInstance}
                          navigation={{
                            nextEl: '.nextel',
                            prevEl: '.prevel'
                          }}
                          slidesPerView={1}>
                          {images.map((item: any, index: any) => (
                            <SwiperSlide
                              className="relative flex !h-[420px] w-full rounded border-2 border-brand-grey125 xsmx:!h-[290px]"
                              key={index}>
                              <>
                                <Image
                                  quality={92}
                                  layout="fill"
                                  objectFit="contain"
                                  placeholder="blur"
                                  priority
                                  blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mO8Uw8AAj0BXe1cD0IAAAAASUVORK5CYII="
                                  src={item}
                                  alt={product.name}
                                />
                              </>
                            </SwiperSlide>
                          ))}
                        </Swiper>
                      </>
                    }
                  </div>
                </div>
              </div>
              {images.length > 1 && <div className="mt-2 lgx:hidden">
                {images.map((item: any, index: any) => (
                  <button
                    onClick={() => navigateToCarouselSlide(index)}
                    key={index}
                    className={`relative mr-[10px] bg-[#f7fafb] h-14 w-20 rounded-md inline-block border ${swiperActiveIndex == index ? 'border-brand-black75' : 'border-brand-grey125 '}`}>
                    <Image
                      quality={92}
                      placeholder="blur"
                      blurDataURL="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mO8Uw8AAj0BXe1cD0IAAAAASUVORK5CYII="
                      layout="fill"
                      objectFit="contain"
                      src={item}
                      className="rounded-md"
                      alt={`${product.name} Contact Lens`}
                      priority={true}
                    />

                  </button>
                ))}
              </div>}
            </div>
            <div>
              <div className="border-b border-brand-grey125 mb-4 pb-4">
                <h1 className="font-bold text-black text-3xl smx:text-2xl font-sans mb-4 xlx:mt-4">
                  {product.name}
                </h1>
                <div className={`${product?.meta?.custom_label ? 'mb-4' : ''}`}>
                  <span className="font-medium inline-flex"><PriceBadge reverse={false} price={product.meta.price} regularPrice={product.meta.regular_price} /></span>
                  {isBundled && <>,<span className="font-medium"> {bundlePackSize} boxes</span></>}
                  {packSize && <span>, {packSize} lenses per box</span>}
                  {frequency && <span className="capitalize">, {frequency}</span>}
                  {lensType && <span className="capitalize">, {lensType}</span>}
                </div>
                {product?.meta?.custom_label &&
                  <div className="htmlContent" dangerouslySetInnerHTML={{ __html: getProperContent(product?.meta?.custom_label) }}>
                  </div>
                }

                <div className='mt-[16px] flex items-center gap-2'>
                  <MarkerS />
                  <p className='text-sm text-[#FF8200]'>This product is excluded from promotions</p>
                </div>
                {/*<h5 className="font-normal text-black text-md font-sans mb-8">
                  {product.regularPrice && formatVisiblePrice(Number((parse as any)(price)), bagItems.currency)}
                  {product.regularPrice && product.salePrice && <div><span className="line-through">{formatVisiblePrice(Number((parse as any)(product.regularPrice)), bagItems.currency)}</span><span>{formatVisiblePrice(Number((parse as any)(product.salePrice)), bagItems.currency)}</span></div>}
              </h5>*/}
              </div>
              <div>
                <div className="mb-5 flex">
                  {<span className="font-medium mr-[30px]">Prescription</span>}
                  {/*<div className="min-h-[18px] flex items-center">
                    <input type="checkbox" className="w-4 h-4 rounded text-white" style={{ accentColor: '#FF8200' }} id="priscription" onChange={() => setSamePriscription(!samePriscription)} />
                    <label htmlFor="priscription" className="text-xs ml-2"> Same prescription for both eyes</label>
                  </div>*/}
                </div>
                <div>
                  <div>
                    {/*<Attributes attr={product?.attributes?.nodes}/>*/}
                    <div className="flex md:flex-row mdx:flex-col">
                      <div className="flex flex-col md:text-left font-medium mdx:flex-row md:self-end mdx:self-start mdx:pl-[100px] mr-3 text-center text-sm mdx:mb-5">
                        <div className={"min-h-[40px] mdx:w-[100px] md:w-[50px] leading-10" + (samePriscription ? " mdx:w-[150px]" : "")}>{!samePriscription ? 'Right' : 'Both'}</div>
                        {!samePriscription && <div className="min-h-[40px] mdx:w-[100px] md:w-[50px] mdx:ml-2 leading-10 md:mt-5">Left</div>}
                      </div>
                      {<LensPowerRanges powerRange={product?.meta?.power_range} />}
                      {/*withColor && <LensPriscriptionField title="Colour" rawData={'Color:' + product?.attributes?.filter((item: any) => item.slug == 'pa_contact-lens-colour')?.[0]?.options.map((item: any) => colors[item]).join(',')} />*/}
                      <span className="md:ml-7">
                        <LensPriscriptionField title="Boxes" renderEmptyValue={false} bold={true} rawData={isBundled ? 'quantity:' + bundlePackSize / 2 : 'quantity:0,1,2,3,4,5,6,7,8,9,10,11,12'} />
                      </span>
                    </div>
                    <>

                      {!fileUpload && <div className="mt-[24px] text-sm text-brand-blue" >
                        <label htmlFor="filelabel" className="cursor-pointer inline-flex">
                          <DocumentUpload className='mr-2' /> Attach your prescription <span className="text-xs ml-1 mt-0.5 text-brand-grey450">(optional)</span>
                        </label>
                      </div>}
                      <div className="relative">
                        <input
                          id="filelabel"
                          type="file"
                          className="hidden"
                          accept="image/png, image/jpeg, application/pdf"
                          {...register('file', {
                            validate: (file: any) => {
                              if (file && file[0].size > 3145728) {
                                return false;
                              }
                              return true;
                            },
                            onChange: (e) => {
                              var fileInput = false;

                              if (e.target.files[0].size > 3145728) {
                                fileErrorPopup();
                                return;
                              }

                              if (e.target.files[0]) {
                                fileInput = true;
                              }

                              const fileExtension = e.target?.files?.[0]?.name.toLocaleLowerCase()
                                ?.split?.('.')
                                ?.pop?.();
                              if (!ALLOWED_FILE_EXTENSIONS.includes(fileExtension)) {
                                return;
                              }

                              if (
                                fileInput &&
                                e.target.files[0].type.includes('image')
                              ) {
                                try {
                                  Resizer.imageFileResizer(
                                    e.target.files[0],
                                    1920,
                                    1080,
                                    'JPEG',
                                    65,
                                    0,
                                    (uri: any) => {
                                      setFile(uri);
                                      setFileUpload(true);
                                      setFileIsPdf(false);
                                    },
                                    'file',
                                    200,
                                    200
                                  );
                                } catch (err) {
                                  console.log(err);
                                }
                              } else {
                                setFile(e.target.files[0]);
                                setFileUpload(true);
                                setFileIsPdf(true);
                              }
                              setFileSrc(URL.createObjectURL(e.target.files[0]));
                              setFileName(e.target.files[0].name);
                            }
                          })}
                        />

                        {fileUpload && (
                          <div className="flex items-between px-4 w-full bg-white items-center rounded mt-5">
                            <div className="mr-[12px] flex h-[32px] w-[32px] flex-shrink-0 items-center justify-center rounded-full bg-brand-orange">
                              <Checkmark fill="#fff" />
                            </div>
                            <div className="my-4 flex-1 overflow-hidden overflow-ellipsis whitespace-nowrap font-sans text-sm">
                              <div>
                                <div className="text-sm font-semibold">File selected</div>
                                <a
                                  href={fileSrc}
                                  target="_blank"
                                  className="cursor-pointer text-brand-grey450 mx-w-lg"
                                  rel="noreferrer">
                                  {fileName}
                                </a>
                              </div>
                            </div>
                            <label
                              onClick={() => {
                                setFileUpload(false);
                                setValue('file', null);
                                setFile(null);
                                clearErrors('file');
                              }}
                              className="">
                              <TrashAlt
                                fill="currentColor"
                              />{' '}
                            </label>
                          </div>
                        )}
                      </div>
                    </>
                  </div>
                </div>
              </div>
              {hasXRTag && <>
                <div className="bg-[#FFF4CC] px-5 py-2 flex items-center text-sm rounded text-brand-grey300 mt-6 ">
                  <span className="mr-4"><InfoIcon /></span> <span>Due to supply chain challenges, these lenses require a minimum 2 to 4 weeks shipping time. For urgent needs, contact us at <a className='text-brand-blue' href='mailto:hello@dresden.vision'>hello@dresden.vision</a> or call <a className='text-brand-blue' href="tel:+0253003003">(02) 5300 3003</a> for suitable alternatives.</span>
                </div>
              </>}
              <div className="mt-2 mb-4 text-sm flex">
                <input id="hp" className={`dresden-checkbox mb relative m-2 pt-2 w-4 h-4 rounded border-brand-grey400`} type="checkbox" onClick={() => setHaveValidPrescription(!haveValidPrescription)} />
                <label className='leading-normal mt-3 pt-0.5 ml-2'>
                  <div>
                    <span className='whitespace-nowrap inline-block'>
                      I confirm that I have a
                    </span>
                    <span className="ml-1 inline-block">
                      <UITooltip place="top"
                        border={true}
                        borderColour={'#D7D8D7'}
                        textColour={'#000'}
                        backgroundColour={'#FFF'}
                        messageWrapperClassName={'mb-3 mt-3'}
                        tooltipWrapperClassName={'!max-w-[300px] leading-normal justify-center items-center md:before-selector-override md:after-selector-override shadow-tooltip'}
                        message={router?.locale === 'ca' || router?.locale === 'au' ? cLTooltipMessageLocale[router?.locale] : cLTooltipMessageLocale['international']}
                        id={'book'}><div className='text-brand-blue whitespace-nowrap'>valid contact lens</div>
                      </UITooltip>
                    </span> prescription.
                  </div>
                </label>
              </div>

              <Button
                disabled={
                  disabledAddToCard ? true : (process.browser && !getSession() ? true : isLoad ? true : false)
                }
                onClick={() => {
                  handleAddtoCart();
                }}
                className="mdx:sticky mdx:bottom-3 text-center bg-brand-black50 justify-center my-auto !px-6 w-full mt-8"
                textClass="font-medium text-white text-sm">
                <span className="flex items-center">
                  {isLoad && (
                    <span className="mr-2 mt-[1px]">
                      <Spinner fill="white" />
                    </span>
                  )}
                  <span>
                    Add to cart {quantity > 0 && ' ' + formatVisiblePrice(
                      isBundled ? price : price * quantity,
                      bagItems.currency
                    )}
                  </span>
                </span>
              </Button>
              <AfterPayInfo total={isBundled ? price : price * quantity} />
              <ZipPayInfo total={isBundled ? price : price * quantity} />
            </div>
          </div>
          <div>
            <div className="flex">
              {product?.description && <div className={"text-lg font-medium m-4 ml-0 mb-0 pb-4 cursor-pointer" + (activeTabIndex == 0 ? ' text-brand-orange border-brand-orange border-b-2' : '')} onClick={() => setActiveTabIndex(0)}>Details</div>}
              {product?.meta?.technical_details && <div className={"text-lg font-medium m-4 mb-0 pb-4 cursor-pointer" + (activeTabIndex == 1 ? ' text-brand-orange border-brand-orange border-b-2 ' : '') + (!product?.description ? 'ml-0' : '')} onClick={() => setActiveTabIndex(1)}>Technical Details</div>}
              {product && <div className={"text-lg font-medium m-4 ml-0 mb-0 pb-4 cursor-pointer" + (activeTabIndex == 2 ? ' text-brand-orange border-brand-orange border-b-2' : '')} onClick={() => setActiveTabIndex(2)}>Shipping and Returns</div>}
            </div>
          </div>

        </div>
        <div className="text-base">
          {activeTabIndex == 0 && <div className="bg-white pb-8">
            {product?.description && <div className="max-w-[1224px] mx-auto px-4 pt-12" dangerouslySetInnerHTML={{ __html: product?.description }}></div>}
          </div>}
          {activeTabIndex == 1 && <div className="bg-white pb-8">
            {product?.meta?.technical_details && <div className="max-w-[1224px] mx-auto px-4 pt-6" dangerouslySetInnerHTML={{ __html: product?.meta?.technical_details }}></div>}
          </div>}
          {activeTabIndex == 2 && <div className="bg-white pb-8">
            {activeTabIndex == 2 && <div className="max-w-[1224px] mx-auto px-4 pt-6">
              <ul>
                <li className="mb-10 mt-8">
                  <div className="flex">
                    <div className="w-[80px] h-[80px] min-w-[80px] bg-[#F5F5F5] mr-6 rounded-lg flex items-center">
                      <PrescriptionAlt className="mx-auto" />
                    </div>
                    <div className="text-base leading-5 text-brand-grey300">
                      <div className="text-lg font-medium text-black mb-1 -top-1">Prescription</div> <span className="font-medium text-black">A valid prescription within the past 12 months is required</span> for the supply of contact lenses. {router?.locale === 'ca' || router?.locale === 'au' ? clPrescriptionFieldContentForLocale[router?.locale] : clPrescriptionFieldContentForLocale['international']}
                    </div>
                  </div>
                </li>
                <li className="mb-10 mt-8">
                  <div className="flex">
                    <div className="w-[80px] h-[80px] min-w-[80px] bg-[#F5F5F5] mr-6 rounded-lg flex items-center">
                      <ShippingIcon className="mx-auto" />
                    </div>
                    <div className="text-base leading-5 text-brand-grey300">
                      <div className="text-lg font-medium text-black mb-1 -top-1">Shipping</div>
                      {
                        'To get your order to you as soon as possible, we often dispatch the items separately. Orders for mixed modalities of contact lenses will arrive in separate packages.'
                      }

                      {router?.locale === 'ca' && (
                        hasXRTag ?
                          ' This item is a custom contact lens and typically takes 3 to 4 weeks for delivery.' :
                          ' Our contact lens delivery times typically range from 1.5 to 2 weeks.'
                      )}

                      {router?.locale === 'au' && (
                        hasXRTag ?
                          ' This item is a custom contact lens and typically takes 4 or more weeks for delivery.' :
                          ' Our contact lens delivery times typically range from 1 to 2 weeks.'
                      )}

                    </div>
                  </div>
                </li>
                <li className="mb-2 mt-8">
                  <div className="flex">
                    <div className="w-[80px] h-[80px] min-w-[80px] bg-[#F5F5F5] mr-6 rounded-lg flex items-center">
                      <ReturnIcon className="mx-auto" />
                    </div>
                    <div className="text-base leading-5 text-brand-grey300">
                      <div className="text-lg font-medium text-black mb-1 -top-1">Returns</div> We accept returns for contact lenses provided their boxes are <span className="font-medium">sealed</span>, <span className="font-medium">unopened</span>, <span className="font-medium">unmarked</span>, and <span className="font-medium">unused</span>. Contact lenses may be returned within 30 days of delivery.
                    </div>
                  </div>
                </li>
              </ul>
            </div>}
          </div>}
        </div>

      </div>
      {/*
        productImage && (
          <ProdSliderModal
            images={getMultipleImages(product?.productImageList)}
            alt={product.name}
            setModalOpen={setModalOpen}
            setIsImported={setIsImported}
            modalOpen={modalOpen}
          />
        )
      */}
      <GlobalSeoMetaTags seoMetaTags={seoMetaTags} />

    </div >);
}

export const getStaticPaths: GetStaticPaths = async () => {
  const paths: any = [];


  if (process.env.NEXT_PUBLIC_ENV !== 'production') {
    return {
      paths: [],
      fallback: 'blocking',
    }
  }

  var contactLensPaths: any = await wcApiDataService('paths/contact-lenses', 'hasProducts&sortByPrice', '');

  if (contactLensPaths) {
    for (const [country, data] of Object.entries(contactLensPaths) as any) {
      if (data != null) {
        let counter = 0;
        //get only 10 paths for each country
        for (const [, item] of Object.entries(data) as any) {
          if (counter < 10) {
            paths.push({
              params: { product: item.product },
              locale: country
            });
          }
          counter++;
        }
      }
    }
  }


  return {
    paths,
    fallback: 'blocking'
  };
};

export const getStaticProps: GetStaticProps = async ({ params, locale }) => {

  if (params == undefined || !params?.product) {
    return {
      redirect: {
        destination: getUrlByLocale(locale, '/shop/contact-lenses'),
        permanent: false,
      },
    }
  }
  const seoMetaTags = await getSeoMetaTags('/shop/contact-lenses/' + params?.product, locale);

  //console.log('locale', locale);
  if (locale == "international") {
    locale = "au";
  }

  var contactLensProduct: any = await wcApiDataService('detail/' + params?.product, '', locale);
  //console.log(contactLensProduct, 'contactLensProduct')
  if (!contactLensProduct) {

    return {
      redirect: {
        destination: getUrlByLocale(locale, '/shop/contact-lenses'),
        permanent: false,
      },
    }
  }


  if (!contactLensProduct) {
    return {
      notFound: true
    };
  }


  return {
    props: {
      product: contactLensProduct,
      seoMetaTags
    },
    //revalidate:300 // In seconds (5 minutes)
  };
};
